module.exports = {"TXTCLI_Available":{"id":"TXTCLI_Available","defaultMessage":"Доступно"},"TXTCLI_Expires":{"id":"TXTCLI_Expires","defaultMessage":"Истекает"}}